<template>
  <Content stretch>
    <slot>no <code>exam_processing_speed</code> component specified</slot>
  </Content>
</template>

<script>
import { Content } from '@neurotrack/web-shared-components'
import essExamProps from '@/mixins/essExamProps'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'exam_processing_speed',
  components: { Content },
  mixins: [essExamProps],
  data() {
    return {
      examTimer: undefined
    }
  },
  computed: {
    ...mapState(['modalVisible'])
  },
  methods: {
    trackEvent(perception) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, perception, {
        root: true
      })
    },
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`, undefined, {
        root: true
      })
    },
    ...mapMutations(['showModal', 'hideModal']),
    handleResponse(data) {
      if (this.isPractice) {
        this.handlePractice(data)
      } else {
        this.handleExam(data)
      }
    },

    handlePractice({ event }) {
      const type = this.trial?.trial_scoring_type
      const shouldBe = type?.split('_')[0] === 'equal' ? 'equal' : 'unequal'
      const isCorrect = event.response === shouldBe

      const headerKey = isCorrect
        ? 'symbol_match_tutorial_correct_heading'
        : 'symbol_match_tutorial_incorrect_heading'

      const bodyKey = `symbol_match_tutorial_${this.step + 1}_paragraph_web`

      this.showModal({
        component: 'Generic',
        props: {
          body: this.$i18n.t(bodyKey),
          label: this.$i18n.t('symbol_match_button_continue')
        },
        title: this.$i18n.t(headerKey)
      })
    },

    handleExam({ event }) {
      const { perception } = event
      this.trackEvent(perception)
      this.$emit('next')
    },

    next({ code }) {
      if (this.modalVisible && code === 'Space') {
        this.hideModal()
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.next)
  },
  beforeDestroy() {
    clearTimeout(this.examTimer)
    window.removeEventListener('keyup', this.next)
  },
  watch: {
    isExamComplete(complete) {
      if (complete) {
        clearTimeout(this.examTimer)
        this.examTimer = undefined
        this.completeExam()
      }
    },
    modalVisible(isShowing, wasShowing) {
      if (wasShowing && !isShowing) {
        this.$emit('next')
      }
    },
    displayType(newValue) {
      if (!this.isPractice && newValue === 'PAIRED_SYMBOL_DIGITS') {
        this.examTimer = setTimeout(() => {
          this.$store.commit(
            `exam/${this.exam}/SET_EXAM`,
            {
              phase: this.phase + 1,
              trial: 0
            },
            { root: true }
          )
          this.completeExam()
        }, 120000)
      }
    }
  }
}
</script>
